module.exports = __webpack_public_path__ + "img/desc.29966126.png";